/**
 * Browser IANA timezone (e.g. America/New_York, Asia/Kolkata).
 * Sent as X-User-Timezone so agent/task runs use the user's local clock like ChatHub.
 */
const TIMEZONE_ALIASES = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
  'Etc/UTC': 'UTC',
  GMT: 'UTC',
};

function normalizeBrowserTimezone(tz) {
  if (!tz || typeof tz !== 'string') return null;
  const trimmed = tz.trim();
  if (!trimmed) return null;
  return TIMEZONE_ALIASES[trimmed] || trimmed;
}

export function getBrowserTimezone() {
  try {
    return normalizeBrowserTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  } catch (_) {
    return null;
  }
}

/** Merge X-User-Timezone into fetch/axios headers when available. */
export function withBrowserTimezoneHeaders(headers = {}) {
  const tz = getBrowserTimezone();
  if (!tz) {
    return { ...headers };
  }
  return { ...headers, 'X-User-Timezone': tz };
}
